/**
 * @file ヘッダーメニューボタン
 *
 */
'use strict';

/**
 * @classname TopShopSelectView
 * @classdesc ヘッダーメニューボタン
 */
export default class TopShopSelectView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('TopShopSelectView.constructor');
		this._$modal = $('.modal-shop-select');
		this.init();
	};

	/**
	 * クリックのコールバック
	 *
	 * @memberof TopShopSelectView
	 * @return {undefined}
	 */
	init() {
		console.log('TopShopSelectView.init');
		this._$modal.modal('show');
	}
}
